import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const FaceChangesCauses = lazyWithPreload(
  () => import('./FaceChangesCauses'),
)
